<script>
    import BulletSep from './util/BulletSep.svelte';
    import { scale, fly } from 'svelte/transition';
</script>

<style>

.menu {
    display: grid;
    
    height: 100%;
    width: 100%;
    margin: 0 auto;
}

@media screen and (max-width: 39.9999rem) {
    .menu {
        grid-template-columns: 1fr;
    }
}
@media screen and (min-width: 40rem) {
    .menu {
        grid-template-columns: 1fr 1fr;
    }
}

.menu div {
    display: flex;
    flex-direction: column;
    align-items: center;
    justify-content: center;
    padding: 1.75rem;
    margin: 0.75rem;
    border-radius: 1.5rem;
    border: 0.15rem solid #000;
    transition: transform 125ms ease-out;
}

.menu div:hover {
    transform: scale(1.05);
}

.menu div a {
    color: white;
    font-size: 2.5em;
    text-transform: uppercase;
}
.menu div a:hover {
    text-decoration: none;
}
</style>

<div class="menu" transition:scale={{delay: 150}}>
    <div class="blue">
        <a href="#/mixer">Mixer</a>
        <p>Mix together existing words to make new meanings</p>
    </div>
    <div class="cyan">
        <a href="#/mouthfeel"><span style="font-size: 0.6em;">Mouthfeel Tuner</span></a>
        <p>Change how text feels in your mouth</p>
    </div>
    <div class="orange">
        <a href="#/respeller">Respeller</a>
        <p>Respell text as though certain letters didn't exist</p>
    </div>
    <div class="red">
        <a href="#/sequencer">Sequencer</a>
        <p>Invent new words by sequencing mouth movements</p>
    </div>
    <div class="purple">
        <a href="#/explorer">Explorer</a>
        <p>Go on an expedition through an endless field of nonsense</p>
    </div>
</div>

